<template>
  <div>
    <template-chart :items="myItems" :yyyy="yyyy"></template-chart>
  </div>
</template>

<script>
export default {
  props: ['item', 'yyyy', 'mm', 'value', 'group', 'prev', 'plan'],
  computed: {
    headers () {
      var temp = []
      temp.push({ title: '在籍合計', key: 17, align: 'start', calc: 'ave', color: '#BBDEFB80' })
      temp.push({ title: '◎', key: 18, align: 'end', calc: 'ave', color: '#D7CCC880' })
      temp.push({ title: '◯', key: 19, align: 'end', calc: 'ave', color: '#D7CCC880' })
      temp.push({ title: '△', key: 20, align: 'end', calc: 'ave', color: '#D7CCC880' })
      temp.push({ title: 'X', key: 21, align: 'end', calc: 'ave', color: '#D7CCC880' })
      return temp
    },
    myItems () {
      var temp = []
      var acts = []
      for (var i in this.headers) {
        var values = this.item['calc_acts'][this.yyyy][this.group].map(v => {
          return v[this.headers[i].key]
        })
        acts.push({
          'key': this.headers[i].key,
          'title': this.headers[i].title,
          'align': 'start',
          'values': values,
          'sum': (this.item['calc_acts_sum'][this.yyyy][this.group][2][this.headers[i].key]).toFixed(),
          'prefix': '',
          'suffix': '',
          'color': this.headers[i].color,
          'calc': 'ave'
        })
      }
      var exec = []
      for (i in this.headers) {
        if (this.headers[i].key !== 17) {
          values = this.item['calc_ycs_exec'][this.yyyy][this.group].map(v => {
            return v[this.headers[i].key - 18]
          })
          exec.push({
            'key': this.headers[i].key + 'exec',
            'title': '',
            'align': 'end',
            'values': values,
            'sum': Math.floor(this.item['calc_ycs_exec_sum'][this.yyyy][this.group][2][this.headers[i].key - 18]),
            'prefix': '',
            'suffix': '%',
            'color': '#D7CCC840',
            'calc': 'ave'
          })
        }
      }
      var prevs = []
      if (this.prev) {
        var prev = this.yyyy - 1
        // var id = this.value ? 'calc_acts_diff' : 'calc_acts'
        if (prev >= 2018) {
          for (i in acts) {
            var id = this.value ? 'calc_ycs_exec' : 'calc_acts'
            var index = this.headers[i].key !== 17 ? acts[i].key - 18 : 17
            if (this.headers[i].key !== 17) {
              id = 'calc_ycs_exec'
            } else {
              id = this.value ? 'calc_acts_diff' : 'calc_acts'
            }
            values = this.item[id][prev][this.group].map((v) => {
              return v[index]
            })
            prevs.push({
              'key': 'prev' + acts[i].key,
              'title': this.value ? '昨年' : '昨年',
              'align': 'end',
              'values': values,
              'sum': (this.item[id + '_sum'][prev][this.group][2][index]).toFixed(),
              'prefix': '',
              'suffix': this.value ? '%' : (this.headers[i].key !== 17 ? '%' : ''),
              'color': '',
              'calc': 'ave'
            })
          }
        }
      }
      for (i in acts) {
        temp.push(acts[i])
        if (acts[i].key !== 17) {
          if (exec.length !== 0) {
            temp.push(exec[i - 1])
          }
        }
        if (prevs.length !== 0) {
          temp.push(prevs[i])
        }
      }
      return temp
    }
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style scoped>
</style>
